import { Stack } from '@mui/material';
import { AuthCardStyled, TitleLogin } from './auth-card.styled';

interface Props {
  children: React.ReactNode;
  title: string;
}

export const AuthCard = ({ children, title }: Props) => {
  return (
    <AuthCardStyled>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <TitleLogin>{title}</TitleLogin>
      </Stack>
      <div>{children}</div>
    </AuthCardStyled>
  );
};
